import { createPortal } from 'react-dom';
import { ReactElement, memo, useEffect } from 'react';

const Portal = ({ children }: { children: ReactElement }) => {
  const mount = document.getElementById('portal-root');
  const el = document.createElement('div');

  useEffect(() => {
    if (!mount) return;

    mount.appendChild(el);

    return () => {
      mount.removeChild(el);
    };
  }, [el, mount]);

  return createPortal(children, el);
};

const PortalMemo = memo(Portal);

export default PortalMemo;
